import { useNavigate } from 'react-router';
import logo from '../../assets/icons/alpha_taxis_logo.svg';
import Button from '../../common/Button/Button';
import Text from '../../common/Text/Text';
import useBooking from '../../hooks/useBooking/useBooking';
import useHotelConfig from '../../hooks/useHotelConfig/useHotelConfig';
import { submitBooking } from '../../utils/booking/booking';
import './Receipt.scss';

const Receipt = () => {
  const navigate = useNavigate();
  const { booking } = useBooking();
  const { hotelConfiguration } = useHotelConfig();

  const handleYes = () => {
    navigate('/email') as void;
  };

  const handleNo = () => {
    submitBooking(booking, hotelConfiguration)
      .then(res => {
        navigate('/booking-confirmation', {
          state: { price: res?.data?.jobs?.[0]?.fareEstimate?.grossAmountCents },
        }) as void;
      })
      .catch(console.error);
  };

  return (
    <div className="receipt">
      <img src={logo} className="logo" />
      <div className="content">
        <Text type="header">Want a receipt by email?</Text>
        <div className="button-group">
          <Button
            buttonStyleType="primary"
            label="Yes"
            handleClick={handleYes}
            customStyling={{ flex: 1 }}
          />
          <Button
            buttonStyleType="primary"
            label="No"
            handleClick={handleNo}
            customStyling={{ flex: 1 }}
          />
        </div>
      </div>
    </div>
  );
};

export default Receipt;
